import { ApiResponse, LoginRequest, LoginResult } from "@/features/login/types";
import { apiClient } from "@/services/api";

export const authService = {
  login: async (username: string, password: string): Promise<LoginResult> => {
    const payload: LoginRequest = {
      username,
      password: password,
    };
    const { data } = await apiClient.post<ApiResponse<LoginResult>>(
      "/auth/login",
      payload,
    );
    if (data.code !== 0) throw new Error(data.msg || "Login failed");
    return data.result;
  },

  // Tidak ada endpoint logout di API — store sudah handle semuanya
  logout: (): void => {
    // Cukup panggil useAuthStore.getState().logout() dari component
    // atau gunakan useLogin hook's handleLogout
  },
};
